import e from"./SortBy.vue_vue&type=script&lang.js";import{render as t}from"./SortBy.vue_vue&type=template&id=78751313&lang.js";e.render=t;export default e;
//# sourceMappingURL=SortBy.vue.js.map
